import Vue from 'vue'
import widgetOptions from '@/helpers/widget-options'

// Directive to apply styles provided in the widget-options object.
// use like so
// <div v-theme="{cssProp: 'widgetOptionKey'}">.
// <a href="#" v-theme="{color: 'color_primary'}">
Vue.directive('theme', {
  bind: function (el, binding, vnode) {
    function applyStyles (el, binding) {
      const themeProps = binding.value

      for (const prop in themeProps) {
        const option = themeProps[prop]
        if (widgetOptions.style[option]) {
          el.style[prop] = widgetOptions.style[option]
        } else {
          el.style[prop] = option
        }
      }
    }

    applyStyles(el, binding)
  },
  unbind: function (el) {}
})

Vue.directive('theme-hover', {
  bind: function (el, binding, vnode) {
    const themeProps = binding.value
    // stash styles
    const stashedStyles = {}
    for (const prop in themeProps) {
      stashedStyles[prop] = el.style[prop]
    }

    function restoreStyles () {
      for (const prop in stashedStyles) {
        el.style[prop] = stashedStyles[prop]
      }
    }

    function applyHoverStyles (el, binding) {
      for (const prop in themeProps) {
        const option = themeProps[prop]
        if (widgetOptions.style[option]) {
          el.style[prop] = widgetOptions.style[option]
        } else {
          el.style[prop] = option
        }
      }
    }

    el.addEventListener('mouseenter', function () {
      applyHoverStyles(el, binding)
    })
    el.addEventListener('focus', function () {
      applyHoverStyles(el, binding)
    })
    el.addEventListener('mouseleave', restoreStyles)
    el.addEventListener('blur', restoreStyles)
  },
  unbind: function (el) {}
})
